import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { PinPreview } from './components/PinPreview';
import { UnlockKeypad } from './components/UnlockKeypad';
import { LogoTimeDate } from '../../components/common/LogoTimeDate';
import { ThreeCardLayout } from '../../components/layouts/ThreeCardLayout';
import { useFirmwareContext } from '../../contexts/FirmwareContext';
import { ROUTE_PATHNAMES } from '../../routes/routeConstants';

export const LockScreenPinCode: React.FC = () => {
  const navigate = useNavigate();
  const { tryUnlock } = useFirmwareContext();

  const PIN_LENGTH = 4;

  const [pin, setPin] = useState<string>('');
  const [pinError, setPinError] = useState<string | null>(null);

  const onCancel = () => {
    navigate(ROUTE_PATHNAMES.lock);
  };

  const onUnlock = async () => {
    const unlocked = await tryUnlock(pin);
    if (!unlocked) {
      setPinError('Incorrect PIN. Please try again.');
      setTimeout(() => {
        setPin('');
        setPinError(null);
      }, 1000);
    }
    // Navigation to dashboard is handled automatically by Router when isLocked changes
  };

  useEffect(() => {
    if (pin.length === PIN_LENGTH) {
      onUnlock();
    }
  }, [pin]);

  const onNumberClick = (number: string) => {
    if (pin.length < 4) {
      const newPin = pin + number;
      setPin(newPin);
    }
  };

  return (
    <ThreeCardLayout
      left={<LogoTimeDate />}
      middle={<UnlockKeypad onNumberClick={onNumberClick} />}
      right={
        <PinPreview
          currentCount={pin.length}
          totalCount={PIN_LENGTH}
          pinError={pinError}
          onCancel={onCancel}
        />
      }
    />
  );
};
